import React, { useEffect, useState } from "react";
import { Plus, X, NotebookPen, Lock } from "lucide-react";
import api from "../../lib/api";
import NoteForm from "./NoteForm";
import NoteCard from "./NoteCard";

function BuyerOverview({ buyer, onClose }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/internal-notes", { params: { buyer } }).then((r) => setRows(r.data)).catch(() => setRows([])); }, [buyer]);
  return (
    <div data-testid="note-buyer-overview" className="border border-[#D4AF37]/40 rounded-md p-3 bg-[#191A1F] space-y-2">
      <div className="flex items-center justify-between">
        <div className="text-xs font-bold text-[#D4AF37]">Catatan untuk buyer “{buyer}”</div>
        <button data-testid="note-buyer-overview-close" onClick={onClose} className="text-[#A8A8AD] hover:text-[#F5F3ED]"><X size={14} /></button>
      </div>
      {rows === null ? <div className="text-xs text-[#A8A8AD]">Memuat…</div> : rows.map((n) => (
        <div key={n.id} className="flex justify-between gap-2 text-xs border-b border-[#35353B] pb-1">
          <span className="text-[#F5F3ED] min-w-0 truncate">{n.supplier_name || "—"}</span>
          <span className="text-[#F2D98D] shrink-0">{n.gold_amount || "—"} · {n.status === "done" ? "Selesai" : "Belum dikirim"}</span>
        </div>
      ))}
    </div>
  );
}

export default function InternalNotes({ peer, onClose }) {
  const [notes, setNotes] = useState(null);
  const [editing, setEditing] = useState(null);
  const [buyer, setBuyer] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get("/internal-notes", { params: { peer_id: peer.id } }).then((r) => { if (alive) setNotes(r.data); }).catch(() => { if (alive) setNotes([]); });
    return () => { alive = false; };
  }, [peer.id]);

  const replace = (n) => setNotes((cur) => (cur.some((x) => x.id === n.id) ? cur.map((x) => (x.id === n.id ? n : x)) : [n, ...cur]));
  const saved = (n) => { replace(n); setEditing(null); };

  return (
    <aside data-testid="internal-notes-panel" className="h-full w-full flex flex-col bg-[#15161A]">
      <div className="p-3 border-b border-[#35353B] flex items-center gap-2">
        <NotebookPen size={16} className="text-[#D4AF37]" />
        <div className="min-w-0 flex-1">
          <div className="text-sm font-bold text-[#F5F3ED]">Catatan Internal</div>
          <div data-testid="internal-notes-peer" className="text-[10px] text-[#A8A8AD] truncate flex items-center gap-1"><Lock size={9} /> {peer.name} · hanya terlihat oleh Anda</div>
        </div>
        {!editing && <button data-testid="note-add-btn" onClick={() => setEditing("new")} className="p-1.5 bg-[#D4AF37] text-[#101114] hover:bg-[#F2D98D] rounded-sm transition-colors"><Plus size={14} /></button>}
        {onClose && <button data-testid="internal-notes-close" onClick={onClose} className="xl:hidden p-1.5 text-[#A8A8AD] hover:text-[#F5F3ED]"><X size={16} /></button>}
      </div>
      <div className="flex-1 overflow-y-auto p-3 space-y-3">
        {buyer && <BuyerOverview buyer={buyer} onClose={() => setBuyer(null)} />}
        {editing && <NoteForm key={editing === "new" ? "new" : editing.id} peer={peer} initial={editing === "new" ? null : editing} onSaved={saved} onCancel={() => setEditing(null)} />}
        {notes === null && <div className="text-xs text-[#A8A8AD]">Memuat…</div>}
        {notes?.length === 0 && !editing && <div data-testid="internal-notes-empty" className="text-xs text-[#A8A8AD] text-center py-8">Belum ada catatan untuk {peer.name}.<br />Klik + untuk menambah.</div>}
        {notes?.map((n) => (editing?.id === n.id ? null : (
          <NoteCard key={n.id} n={n} onEdit={setEditing} onChanged={replace} onBuyer={setBuyer}
            onDeleted={(id) => setNotes((cur) => cur.filter((x) => x.id !== id))} />
        )))}
      </div>
    </aside>
  );
}
